import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	min-height: 0;
`;

export const ScrollingArea = styled.div`
	flex: 1;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 14px;
	scrollbar-width: thin;
	&::-webkit-scrollbar {
		width: 8px;
	}
	scrollbar-color: ${({ theme }) => theme.gray[400]} ${({ theme }) => theme.gray[100]};
`;

export const Comment = styled.div`
	margin-bottom: 16px;
	padding: 12px;
	background-color: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const CommentHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 8px;
`;

export const UserInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

export const UserIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const UserId = styled.div`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Timestamp = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
`;

export const CommentContent = styled.div`
	font-size: 13px;
	line-height: 18px;
	color: ${({ theme }) => theme.gray[1000]};

	// Markdown styles
	p {
		margin: 0 0 8px 0;
		&:last-child {
			margin-bottom: 0;
		}
	}

	code {
		background-color: ${({ theme }) => theme.gray[200]};
		padding: 2px 4px;
		border-radius: 4px;
		font-size: 12px;
	}

	pre {
		background-color: ${({ theme }) => theme.gray[100]};
		padding: 8px;
		border-radius: 4px;
		overflow-x: auto;
		margin: 8px 0;
	}
`;

export const Thread = styled.div`
	margin-bottom: 16px;
`;

export const ReplyList = styled.div`
	margin-left: 20px;
	margin-top: 8px;
	padding-left: 12px;
	border-left: 2px solid ${({ theme }) => theme.gray[200]};
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 20px 10px;
	text-align: center;
`;

export const EmptyStateIcon = styled.div`
	margin-bottom: 16px;
	opacity: 0.6;
`;

export const EmptyStateText = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[800]};
	margin-bottom: 10px;
`;

export const EmptyStateSubtext = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
`;
